module.exports = __webpack_public_path__ + "static/media/github.1f24f07c.svg";